module.exports = __webpack_public_path__ + "static/media/expend3.633273e.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/expend3.mp4
// module id = ymo4
// module chunks = 0